import { useContext } from "react";
import { RevealingContext } from "./textRevealState/RevealingContext";

/** True while any assistant bubble is still revealing. False with no provider. */
export const useIsTextRevealing = (): boolean => useContext(RevealingContext);
